import _ from "lodash";
import { getIn } from "formik";
import React from "react";

import { CheckboxOld, Text, TextColors, TextTypes } from "../../../component-library";

import "./styles.scss";

// NOTE: THIS PATTERN WAS COPIED FROM the care management form
export const WaitlistFormCheckbox = ({
  checkboxClassName,
  checkboxOptions = [],
  checkboxWrapperClassName,
  formikProps,
  name,
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const checkedValues = formikProps.values[name];

  const handleChange = async (event, isChecked) => {
    const value = event.target.value;
    let newCheckedValue = _.cloneDeep(checkedValues);

    // if the checkbox is not currently checked
    // check it
    if (!isChecked) {
      newCheckedValue.push(value);
    }
    // if it is checked remove it from the checked values
    else {
      newCheckedValue = newCheckedValue.filter((item) => item !== value);
    }

    await formikProps.setFieldValue(name, newCheckedValue);
  };

  return (
    <>
      <div className={checkboxWrapperClassName}>
        {checkboxOptions.map((option) => {
          const checked = checkedValues?.includes(option.value);

          return (
            <CheckboxOld
              checked={checked}
              className={checkboxClassName}
              disabled={option.disabled ?? false}
              key={option.value}
              label={option.label}
              labelClassName="ml-2"
              name={option.value}
              onClick={(e) => handleChange(e, checked)}
              value={option.value}
              version="v2"
            />
          );
        })}
      </div>

      {errorMessage && isTouched && (
        <Text className="pt-2" color={TextColors.red} type={TextTypes.small}>
          {errorMessage}
        </Text>
      )}
    </>
  );
};
